<template>
  <el-form  label-width="auto" ref="form" :rules="rules" :model="formData">
    <el-form-item label="使用地区" prop="area">
      <el-input placeholder="使用地区" v-model="formData.area" />
    </el-form-item>
    <el-form-item label="使用地区后台" prop="areaBack">
      <dict-select  flag="AREA_BACK_LIST" v-model="formData.areaBack" />
    </el-form-item>
    <el-form-item label="对应前台语言版本" prop="languageVersionFront">
      <dict-select flag="LANGUAGE-VERSIONFRONT" v-model="formData.languageVersionFront" />
    </el-form-item>
    <el-form-item label="对应后台语言版本" prop="languageVersionBack">
      <dict-select flag="LANGUAGE_VERSION_BACK" v-model="formData.languageVersionBack" />
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
      <el-button  @click="resetForm">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {resetEmpty} from "@/utils/common";
import DictSelect from "@/components/dict/DictSelect";

export default {
  name: "LangForm",
  components: {DictSelect},
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        area: "",
        areaBack: "",
        languageVersionFront: "",
        languageVersionBack: ""
      },
      rules: {
        area: {required: true, message: '请输入使用地区', trigger: 'blur'},
        areaBack: {required: true, message: '请选择使用地区后台', trigger: 'change'},
        languageVersionFront: {required: true, message: '请选择对应前台语言版本', trigger: 'change'},
        languageVersionBack: {required: true, message: '请选择对应后台语言版本', trigger: 'change'}
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if(!valid) return;
        this.$emit("confirm", this.formData);
      })
    },

    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    }
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
      }
    }
  }

}
</script>

<style scoped>

.el-form {
  max-width: 500px;
}

/deep/ .el-select {
  width: 100%;
}
</style>
